import { imageLoader } from "@/lib/sanity/client";
import ImageComponent from "next/image";
import React, { forwardRef, useState } from "react";
import { Wrapper } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Image = ImageComponent as any;

type Props = {
  image?: any;
};

const Thumbnail = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { image } = props;
  const [loaded, setLoaded] = useState(false);

  return (
    <Wrapper ref={ref} $hasLoaded={loaded}>
      {image?.asset?.url && (
        <Image
          src={image.asset.url}
          layout="fill"
          objectFit="cover"
          alt={image.alt || ""}
          loader={imageLoader}
          sizes="50vw"
          onLoadingComplete={() => setLoaded(true)}
        />
      )}
    </Wrapper>
  );
});

Thumbnail.displayName = "Illustration";

export default Thumbnail;
